import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { HASH_LINK_MIN_CHARS } from '../../lib/messaging/hashLink';
import { searchHashLinks } from '../../services/search/hashLinkSearch';
import { useAuthStore } from '../../store/useAuthStore';

export function useHashLinkSearch(query: string | null) {
  const [debounced, setDebounced] = useState('');
  const isInitialized = useAuthStore((s) => s.isInitialized);
  const session = useAuthStore((s) => s.session);

  useEffect(() => {
    if (query === null) {
      setDebounced('');
      return;
    }
    const t = setTimeout(() => setDebounced(query), 200);
    return () => clearTimeout(t);
  }, [query]);

  const term = debounced.trim();
  const ready = query !== null && term.length >= HASH_LINK_MIN_CHARS;

  return useQuery({
    staleTime: 30_000,
    queryKey: ['hash-link-search', term],
    queryFn: () => searchHashLinks(term),
    enabled: ready && isInitialized && !!session,
  });
}
